import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filter',
    standalone: false
})
export class FilterPipe implements PipeTransform {
    transform(items: any[], field: string, value: string | boolean): any[] {
        if (!items) { return []; }
        if (value === true || value === false) {
            return items.filter(it => it[field] === value);
        } else {
            if (!value || value.length === 0) { return items; }
            return items.filter(it =>
                it[field].toLowerCase().indexOf(value.toLowerCase()) !== -1);
        }

    }
}
